import { ADMIN_FUNCTIONS, SC_MODULES } from '@app/constants/sc.modules';
import myIcon from '@app/assets/images/icons/stats.svg';
import InBaoCaoPage from '@modules/school-service/pages/InBaoCaoPage';
import { IRouteConfig } from '../route.types';

/**
 * In báo cáo
 */
const generalRoutes: IRouteConfig[] = [
    {
        name: 'IN BÁO CÁO',
        icon: myIcon,
        isMenu: true,
        isRoute: true,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        link: '/general',
        path: '/general',
        main: () => <InBaoCaoPage />,
        functionId: ADMIN_FUNCTIONS.GENERAL_LIST,
    },
];

export default generalRoutes;
